import { render, staticRenderFns } from "./ServerInfoTabYFB.vue?vue&type=template&id=60cd0311&"
import script from "./ServerInfoTabYFB.vue?vue&type=script&lang=js&"
export * from "./ServerInfoTabYFB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports